import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import Reveal from '../../../shared/Reveal/Reveal';
import { useHomeWealthSavingsContent } from '../../../../hooks/useHomeWealthSavingsContent';
import './WealthAndSavings.css';

const WealthAndSavings = () => {
  const { content, isLoading } = useHomeWealthSavingsContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text, cta, featureImage, checkIcon, products } = content;
  const titleLines = title.split('\n').filter(Boolean);

  return (
    <section className="wealth-savings">
      <div className="wealth-savings__inner">
        <div className="wealth-savings__grid">
          <Reveal className="wealth-savings__feature">
            <img
              className="wealth-savings__feature-image"
              src={featureImage}
              alt=""
              aria-hidden="true"
            />
            <div className="wealth-savings__feature-overlay" />
            <div className="wealth-savings__feature-content">
              <div className="wealth-savings__feature-copy">
                <p className="wealth-savings__eyebrow">{eyebrow}</p>
                <h2 className="wealth-savings__title">
                  {titleLines.map((line, index) => (
                    <span key={line}>
                      {line}
                      {index < titleLines.length - 1 ? <br /> : null}
                    </span>
                  ))}
                </h2>
                <p className="wealth-savings__text">{text}</p>
              </div>

              {cta?.text && cta?.url ? (
                <Link to={cta.url} className="wealth-savings__cta luxury-btn">
                  {cta.text}
                  <HiArrowRight className="wealth-savings__cta-icon" aria-hidden="true" />
                </Link>
              ) : null}
            </div>
          </Reveal>

          <div className="wealth-savings__cards">
            {products.map(({ name, description, features, icon, to }, index) => (
              <Reveal key={name} delay={index * 90}>
                <article className="wealth-savings__card">
                  <div className="wealth-savings__card-icon">
                    <img src={icon} alt="" aria-hidden="true" />
                  </div>

                  <div className="wealth-savings__card-body">
                    <h3 className="wealth-savings__card-name">{name}</h3>
                    <p className="wealth-savings__card-text">{description}</p>

                    <ul className="wealth-savings__card-list">
                      {features.map((feature) => (
                        <li key={feature} className="wealth-savings__card-item">
                          <img
                            className="wealth-savings__card-check"
                            src={checkIcon}
                            alt=""
                            aria-hidden="true"
                          />
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <Link to={to} className="wealth-savings__card-link">
                      Learn more
                      <HiArrowRight
                        className="wealth-savings__card-link-icon"
                        aria-hidden="true"
                      />
                    </Link>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WealthAndSavings;
